
import React from "react";
import SensorBase from "./SensorBase";

const FIELD = "soilTemp";
const UNIT = "C";

const SoilTemperature: React.FC = () => {
  return (
    <SensorBase field={FIELD} unit={UNIT}></SensorBase>
  );
};

export default SoilTemperature;
